import React, { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const WelcomeBanner = () => {
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetch(`${API_URL}/api/settings/customizer-welcome`)
      .then((r) => r.json())
      .then((data) => setMessage(data.message || ''))
      .catch(() => setMessage(''));
  }, []);

  if (!message) return null;

  return (
    <div
      data-testid="customizer-welcome-banner"
      className="bg-gradient-to-r from-[#7B1E2B] to-[#001B2A] rounded-lg p-5 sm:p-6 mb-8 text-white flex items-start gap-4 shadow-lg"
    >
      <div className="flex-shrink-0 w-11 h-11 bg-white/15 rounded-full flex items-center justify-center">
        <MessageCircle className="h-5 w-5 text-[#E6D7B3]" />
      </div>
      <div>
        <p className="text-xs uppercase tracking-widest text-[#E6D7B3] font-semibold mb-1">A note from your designer</p>
        <p className="text-lg sm:text-xl font-serif leading-snug">{message}</p>
      </div>
    </div>
  );
};
